import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import NavbarAuth from "../components/NavbarAuth.js";
import Footer from "../components/Footer.js";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { toastWarning } from "../utils/Alerts.js";

const NewIndividualForm = () => {
  const navigate = useNavigate();
  const base_url = process.env.REACT_APP_BASE_URL;

  //Form Variable
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [otherName, setOtherName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumber2, setPhoneNumber2] = useState("");
  const [gender, setGender] = useState("Male");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [mothersMaidenName, setMothersMaidenName] = useState("");
  const [sourceOfFunds, setSourceOfFunds] = useState("");
  const [expiryDateError, setExpiryDateError] = useState("");

  // Nationality and address information
  const [nationality, setNationality] = useState("");
  const [state, setState] = useState("");
  const [lga, setLga] = useState("");
  const [address, setAddress] = useState("");
  const [addressCity, setAddressCity] = useState("");
  const [addressState, setAddressState] = useState("");
  const [addressCountryCode, setAddressCountryCode] = useState("");

  // financial and bank information
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bvn, setBvn] = useState("");

  // next of kin information
  // const [nextOfKinTitleCd, setNextOfKinTitleCd] = useState("");
  const [nextOfKinLastName, setNextOfKinLastName] = useState("");
  const [nextOfKinFirstName, setNextOfKinFirstName] = useState("");
  const [nextOfKinOtherNames, setNextOfKinOtherNames] = useState("");
  const [nextOfKinGenderCd, setNextOfKinGenderCd] = useState("Male");
  const [nextOfKinRelationshipCd, setNextOfKinRelationshipCd] = useState("037");
  const [nextOfKinTelephone, setNextOfKinTelephone] = useState("");
  const [nextOfKinEmailAddress, setNextOfKinEmailAddress] = useState("");
  const [nextOfKinAddressStreet, setNextOfKinAddressStreet] = useState("");
  const [nextOfKinAddressCountryCd, setNextOfKinAddressCountryCd] =
    useState("");
  const [nextOfKinAddressState, setNextOfKinAddressState] = useState("");
  const [nextOfKinAddressLga, setNextOfKinAddressLga] = useState("");
  const [nextOfKinAddressZipCode, setNextOfKinAddressZipCode] = useState("");

  // state variables for identification
  const [identityDocTypeCd, setIdentityDocTypeCd] = useState("");
  // const [identityDocName, setIdentityDocName] = useState("");
  const [identityDocNo, setIdentityDocNo] = useState("");
  const [identityDocIssueDate, setIdentityDocIssueDate] = useState("");
  const [identityDocExpiryDate, setIdentityDocExpiryDate] = useState("");
  const [identityDocIssueAuthority, setIdentityDocIssueAuthority] =
    useState("");

  const [govtID, setGovtId] = useState("");
  const [utilityBill, setUtilityBill] = useState("");
  const [passport, setPassport] = useState("");
  const [signature, setSignature] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [bvnError, setBVNError] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");

  const today = new Date();
  const minDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );
  const referer = sessionStorage.getItem("referer");
  // console.log(referer);

  const handleGovtID = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (!file || !allowedTypes.includes(file.type)) {
      alert("Invalid file type. Only JPG, PNG or PDF allowed.");
      event.target.value = "";
      return;
    }
    // setGovtId(file);
    if (file && file.size <= 100 * 1024) {
      const reader = new FileReader();
      setGovtId(file);
      reader.onloadend = () => {
        // Convert file to base64 and set it to state
      };
      reader.readAsDataURL(file);
    } else {
      // File size exceeds the limit, display error and prevent state update
      alert("ID size exceeds 100 KB. Please choose a smaller file.");
      setGovtId("");
      event.target.value = "";
    }
  };
  const handleutilityBill = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (!file || !allowedTypes.includes(file.type)) {
      alert("Invalid file type. Only JPG, PNG or PDF allowed.");
      event.target.value = "";
      return;
    }
    // setUtilityBill(file);
    if (file && file.size <= 100 * 1024) {
      const reader = new FileReader();
      setUtilityBill(file);
      reader.onloadend = () => {
        // Convert file to base64 and set it to state
        // setUtilityBill(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // File size exceeds the limit, display error and prevent state update
      alert("Utility bill size exceeds 100 KB. Please choose a smaller file.");
      setUtilityBill("");
      event.target.value = "";
    }
  };
  const handlePassport = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (!file || !allowedTypes.includes(file.type)) {
      alert("Invalid file type. Only JPG, PNG or PDF allowed.");
      event.target.value = "";
      return;
    }
    // setPassport(file);
    if (file && file.size <= 100 * 1024) {
      const reader = new FileReader();
      setPassport(file);
      reader.onloadend = () => {
        // Convert file to base64 and set it to state
        // setPassport(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // File size exceeds the limit, display error and prevent state update
      alert("Passport size exceeds 100 KB. Please choose a smaller file.");
      setPassport("");
      event.target.value = "";
    }
  };
  const handleSignature = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (!file || !allowedTypes.includes(file.type)) {
      alert("Invalid file type. Only JPG, PNG or PDF allowed.");
      event.target.value = "";
      return;
    }
    // setSignature(file);
    if (file && file.size <= 100 * 1024) {
      const reader = new FileReader();
      setSignature(file);
      reader.onloadend = () => {
        // Convert file to base64 and set it to state
        // setSignature(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // File size exceeds the limit, display error and prevent state update
      alert("Signature size exceeds 100 KB. Please choose a smaller file.");
      setSignature("");
      event.target.value = "";
    }
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    if (isChecked === true) {
      setIsChecked(false);
    } else {
      setIsChecked(true);
    }
  };

  const handlePhoneNumberChange = (e) => {
    const inputValue = e.target.value;

    // Check if the input value consists of digits only and has length <= 11
    if (/^\d{0,11}$/.test(inputValue)) {
      setPhoneNumber(inputValue);
      setPhoneNumberError(
        inputValue.length < 11 ? "Phone number must be 11 digits" : ""
      );
    }
  };

  const handleBVNChange = (e) => {
    const inputValue = e.target.value;

    // Check if the input value consists of digits only and has length <= 11
    if (/^\d{0,11}$/.test(inputValue)) {
      setBvn(inputValue);
      setBVNError(inputValue.length < 11 ? "BVN must be 11 digits" : "");
    }
  };

  const handleAccountNumberChange = (e) => {
    const inputValue = e.target.value;

    // Check if the input value consists of digits only and has length <= 11
    if (/^\d{0,10}$/.test(inputValue)) {
      setAccountNumber(inputValue);
      setAccountNumberError(
        inputValue.length < 10 ? "Account number must be 10 digits" : ""
      );
    }
  };

  const handleKinPhoneNumberChange = (e) => {
    const inputValue = e.target.value;

    // Check if the input value is numeric and has a length between 1 and 11
    // if (/^\d+$/.test(inputValue) && inputValue.length <= 11) {
    //     setNextOfKinTelephone(inputValue);
    // } else if (inputValue === "") {
    //     // Clear the input only if it's empty
    //     setNextOfKinTelephone("");
    // }
    if (/^\d{0,11}$/.test(inputValue)) {
      setNextOfKinTelephone(inputValue);
      setPhoneNumberError(
        inputValue.length < 11 ? "Phone number must be 11 digits" : ""
      );
    }
  };

  const handleIssueDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const currentDate = new Date();
    if (selectedDate > currentDate) {
      setIdentityDocIssueDate("");
      alert("Issue date cannot be after the present day");
    } else {
      setIdentityDocIssueDate(e.target.value);
      if (new Date(identityDocExpiryDate) < selectedDate) {
        setIdentityDocExpiryDate("");
      }
    }
  };

  const handleExpiryDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const issueDate = new Date(identityDocIssueDate);
    if (selectedDate < issueDate) {
      setExpiryDateError("Expiry date cannot be before the issue date");
    } else {
      setExpiryDateError("");
      setIdentityDocExpiryDate(e.target.value);
    }
  };

  // const [otherName, setOtherName] = useState("");

  // STATE VARIABLES FOR DROPDOWN OPTIONS
  const [error, setError] = useState(null);
  const [titleList, setTitleList] = useState([]);
  const [relationshipList, setRelationshipList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [identityList, setIdentityList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [nationalityList, setNationalityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [lgaList, setLgaList] = useState([]);

  const [initialLgaList, setInitialLgaList] = useState([]);
  const [stList, setStList] = useState([]);
  const [nokStateList, setNokStateList] = useState([]);
  const [nokLgaList, setNokLgaList] = useState([]);

  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [step4, setStep4] = useState(false);

  const [step1Status, setStep1Status] = useState(true);
  const [step2Status, setStep2Status] = useState(false);
  const [step3Status, setStep3Status] = useState(false);
  const [step4Status, setStep4Status] = useState(false);
  const [finalStep, setFinalStep] = useState(false);

  //Signup error variables
  const [isPending, setIsPending] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isPending) return;

    setIsPending(true);

    const payload = {
      last_name: lastName,
      first_name: firstName,
      other_names: otherName,
      gender_cd: gender,
      marital_status_cd: "",
      birth_date: dateOfBirth,
      wedding_anniversary_date: "",
      nationality_cd: nationality,
      mobile_phone_no: phoneNumber,
      primary_email_address: email,
      address_street: address,
      address_city: lga,
      address_state_cd: state,
      address_country_cd: addressCountryCode,
      bank_cd: bankName,
      bank_account_name: accountName,
      bank_account_no: accountNumber,
      bank_branch_name: "",
      bank_address_details: "",
      bank_bvn_no: bvn,
      next_of_kin_last_name: nextOfKinLastName,
      next_of_kin_first_name: nextOfKinFirstName,
      next_of_kin_other_names: nextOfKinOtherNames,
      next_of_kin_gender_cd: nextOfKinGenderCd,
      next_of_kin_relationship_cd: nextOfKinRelationshipCd,
      next_of_kin_telephone: nextOfKinTelephone,
      next_of_kin_email_address: nextOfKinEmailAddress,
      next_of_kin_address_street:
        nextOfKinAddressStreet || nextOfKinAddressState,
      next_of_kin_address_city: nextOfKinAddressState,
      next_of_kin_address_country_cd: nextOfKinAddressCountryCd,
      next_of_kin_address_zip_code: "",
      identity_doc_type_cd: identityDocTypeCd,
      identity_doc_name: identityDocTypeCd,
      identity_doc_no: identityDocNo,
      identity_doc_issue_date: identityDocIssueDate,
      identity_doc_expiry_date: identityDocExpiryDate,
      identity_doc_issue_authority: identityDocIssueAuthority,
    };

    try {
      const formData = new FormData();

      // Append all payload fields
      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      // Append files
      formData.append("governmentId", govtID);
      formData.append("utility", utilityBill);
      formData.append("passport", passport);
      formData.append("signature", signature);

      // Referral code
      formData.append("uniqueID", referer || "");

      const response = await axios.post(
        `${base_url}/onboarding/create-individual2`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response.data);

      if (sessionStorage.getItem("corporate")) {
        sessionStorage.removeItem("corporate");
      }

      sessionStorage.setItem("individualData", JSON.stringify(payload));

      toast.success("Your account was successfully created.", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });

      setTimeout(() => {
        navigate("/products");
      }, 3000);
    } catch (error) {
      console.error(error);

      toast.error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
        {
          position: "top-right",
          autoClose: 4000,
          theme: "light",
        }
      );
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => {
    setError(null);
    const fetchData = async () => {
      try {
        const returnData = await fetch("./data/dropdown-options.json");

        if (!returnData.ok) {
          toast.error("Lost connection, please try again later!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

        const data = await returnData.json();

        setTitleList(data.titles.title);
        setInitialLgaList(data.lga.lga);
        setCountryList(data.countries.country);
        setStateList(data.states.state);
        setRelationshipList(data.relationship.relation);
        setBankList(data.banks.bank);
        setNationalityList(data.nationality.nation);
        setIdentityList(data.identity.identity);
      } catch (error) {
        toast.error("Lost connection, please try again later!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    };

    fetchData();
  }, []);

  const handleNationalityChange = (e) => {
    const selectedNationality = e.target.value;
    // Update the selected country
    setNationality(selectedNationality);
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;

    const states = stateList.filter(
      (state) => state.COUNTRY_CD === selectedCountry
    );

    setStList(states);
    setAddressCountryCode(selectedCountry);

    // Reset selections
    setState("");
    setLga("");
    setLgaList([]);
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;

    setState(selectedState);

    if (addressCountryCode === "NGA") {
      const lgas = initialLgaList.filter(
        (lga) => lga.STATE_CD === selectedState
      );

      setLgaList(lgas);
    } else {
      setLgaList([]);
    }

    setLga("");
  };

  const handleNokCountryChange = (e) => {
    const selectedCountry = e.target.value;

    setNextOfKinAddressCountryCd(selectedCountry);

    const stateslist = stateList.filter(
      (state) => state.COUNTRY_CD === selectedCountry
    );

    setNokStateList(stateslist);

    setNextOfKinAddressState("");
  };

  const handleNokStateChange = (e) => {
    const selectedState = e.target.value;

    setNextOfKinAddressState(selectedState);

    const lgas = initialLgaList.filter((lga) => lga.STATE_CD === selectedState);

    setNokLgaList(lgas);

    setNextOfKinAddressLga("");
  };

  // check all required fields to make sure they are valid before submitting form
  // page 1 values

  function ValidateEmail(email) {
    var validRegex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email) {
      // Check if the email is provided
      if (email.match(validRegex)) {
        // alert("Valid email address!");
        return true;
      } else {
        toastWarning("Invalid email address!");
        // email.focus(); // or document.form1.text1.focus(); if form1 exists
        return false;
      }
    } else {
      // Handle the case where no email is provided
      // alert("Please provide an email address!");
      return false;
    }
  }

  const handleStep1Submit = (e) => {
    e.preventDefault();

    const isEmailValid = ValidateEmail(email);
    const selectedDateOfBirth = new Date(dateOfBirth);

    const isNigeria = addressCountryCode === "NGA";

    if (
      firstName &&
      lastName &&
      otherName &&
      phoneNumber &&
      gender &&
      email &&
      dateOfBirth &&
      maritalStatus &&
      nationality &&
      address &&
      addressCountryCode &&
      (!isNigeria || (state && state !== "State of Residence")) &&
      (!isNigeria || (lga && lga !== "Select LGA")) &&
      isEmailValid &&
      !phoneNumberError
    ) {
      if (selectedDateOfBirth <= minDate) {
        setStep1(false);
        setStep2(true);
        setStep3(false);
        setStep4(false);
        setIsChecked(false);
        setFinalStep(false);
      } else {
        toastWarning(
          "Date of Birth must indicate that you are at least 18 years old."
        );
      }
    } else {
      toastWarning(
        "Please complete all fields before proceeding to the next step."
      );
    }
  };

  const handleStep2Submit = (e) => {
    e.preventDefault();
    const isEmailValid = nextOfKinEmailAddress
      ? ValidateEmail(nextOfKinEmailAddress)
      : true;
    const isNigeria = nextOfKinAddressCountryCd === "NGA";

    if (
      dateOfBirth &&
      nextOfKinFirstName &&
      nextOfKinLastName &&
      nextOfKinTelephone &&
      nextOfKinGenderCd &&
      nextOfKinRelationshipCd &&
      nextOfKinAddressCountryCd &&
      nextOfKinAddressCountryCd !== "Country of Residence" &&
      (!isNigeria || nextOfKinAddressState) &&
      isEmailValid &&
      !phoneNumberError
    ) {
      // console.log("all set")
      setStep1(false);
      setStep2(false);
      setStep3(true);
      setStep4(false);
      setIsChecked(false);
      setFinalStep(false);
      // console.log(firstName + " " + lastName)
    } else if (!isEmailValid) {
      // toastWarning("Ensure Next of Kin email is valid or proceed to the next step")
    } else {
      toastWarning(
        "Please complete all fields before proceeding to the next step."
      );
    }
  };

  const handleStep3Submit = (e) => {
    e.preventDefault();
    if (
      bankName &&
      accountName &&
      accountNumber &&
      bvn &&
      !bvnError &&
      !accountNumberError
    ) {
      // console.log("all set")
      setStep1(false);
      setStep2(false);
      setStep3(false);
      setStep4(true);
      setIsChecked(false);
      setFinalStep(false);
    } else {
      toastWarning(
        "Please complete all fields before proceeding to the next step."
      );
    }
  };

  const handleStep4Submit = (e) => {
    e.preventDefault();
    if (
      identityDocNo &&
      identityDocTypeCd &&
      identityDocIssueDate &&
      identityDocExpiryDate &&
      govtID &&
      passport &&
      utilityBill &&
      signature
    ) {
      console.log("all set");
      setStep1(false);
      setStep2(false);
      setStep3(false);
      setStep4(false);
      setIsChecked(false);
      setFinalStep(true);
    } else {
      toastWarning(
        "Please complete all fields before proceeding to the next step."
      );
    }
  };

  return (
    <>
      <ToastContainer />
      <NavbarAuth />
      <div style={{ background: "#efefef" }}>
        <br />
        <br />
        <div className="container mt-5 my-5" style={{ minHeight: "100vh" }}>
          <div className="row">
            <div className="col-xs-0 col-md-2"></div>
            <div className="col-xs-12 col-md-8 col-lg-8">
              <div className="d-flex btn-group mb-4">
                {/* step 1 */}
                {step1 ? (
                  <div
                    className="step-btn flex-fill flex-fill"
                    onClick={() => {
                      setStep1(true);
                      setStep2(false);
                      setStep3(false);
                      setStep4(false);
                      setIsChecked(false);
                      setFinalStep(false);
                    }}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person-circle text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 1
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Personal Info
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="horizontal-line" />
                                            </div> */}
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={() => {
                      setStep1(true);
                      setStep2(false);
                      setStep3(false);
                      setStep4(false);
                      setIsChecked(false);
                      setFinalStep(false);
                    }}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person-circle mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 1
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Personal Info
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                    </div>
                  </div>
                )}
                {/* end step 1 */}

                <div className="flex-fill d-flex justify-content-center align-items-center text-center">
                  <div className="">
                    <hr className="horizontal-line" />
                  </div>
                </div>
                {/* step 2 */}

                {step2 ? (
                  <div
                    className="step-btn flex-fill"
                    onClick={handleStep1Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-geo-fill text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 2
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Next Of Kin
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="horizontal-line" />
                                            </div> */}
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={handleStep1Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-geo-fill mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 2
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Next Of Kin
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="horizontal-line" />
                                            </div> */}
                    </div>
                  </div>
                )}
                {/* end step 2 */}

                <div className="flex-fill d-flex justify-content-center align-items-center text-center">
                  <div className="">
                    <hr className="horizontal-line" />
                  </div>
                </div>
                {/* step 3 */}
                {step3 ? (
                  <div
                    className="step-btn flex-fill"
                    onClick={handleStep2Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-bank text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 3
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Bank Details
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="horizontal-line" />
                                            </div> */}
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={handleStep2Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-bank mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 3
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Bank Details
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="horizontal-line" />
                                            </div> */}
                    </div>
                  </div>
                )}
                {/* end step 3 */}

                <div className="flex-fill d-flex justify-content-center align-items-center text-center">
                  <div className="">
                    <hr className="horizontal-line" />
                  </div>
                </div>
                {/* step 4 */}
                {step4 ? (
                  <div
                    className="step-btn flex-fill"
                    onClick={handleStep3Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person-vcard text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 4
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          ID Verification
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={handleStep3Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person-vcard mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 4
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          ID Verification
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                    </div>
                  </div>
                )}
                {/* end step 4 */}
              </div>

              {/* LOGIN BOX */}
              <div className="login-container px-4 py-3 shadow bg-white   ">
                <form
                  onSubmit={handleSubmit}
                  className="mt-3"
                  encType="multipart/form-data"
                >
                  {step1 && (
                    <section className="fade-wrapper">
                      <div className="d-flex">
                        <div>
                          <h2>
                            <i className="bi-person-circle m-1 me-2 text-custom"></i>
                          </h2>
                        </div>
                        <div>
                          <h5
                            className="section-title text-custom"
                            style={{ marginBottom: "-5px" }}
                          >
                            Biodata
                          </h5>
                          <small className="text-muted">
                            Please provide us with your personal information
                          </small>
                        </div>
                      </div>
                      <p
                        className="mt-3 bold text-small"
                        style={{ marginBottom: "5px" }}
                      >
                        Personal Information
                      </p>
                      <div className="d-flex">
                        {/* <div className="me-1 flex-fill w-50">
                                                <div className="input-group">
                                                    <span class="input-group-text input-group-text-custom">
                                                        <i class="bi bi-person"></i>
                                                    </span>
                                                    <select className="form-control custom-input-group" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" required>
                                                        <option>Select Title</option>
                                                        {titleList.map((tit) => {
                                                            return (
                                                                <option value={tit.TITLE_CD}>
                                                                    {tit.TITLE_DSC}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>

                                                </div>
                                            </div> */}

                        <div className="flex-fill w-50 me-1">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-person"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={firstName}
                              onChange={(e) => setFirstName(e.target.value)}
                              placeholder="First name"
                              required
                            />
                          </div>
                        </div>
                        <div className="flex-fill w-50 me-1">
                          {/* <small>Last Name</small> */}
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-person"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                              placeholder="Last name"
                              required
                            />
                          </div>
                        </div>
                        <div className="flex-fill w-50 me-1">
                          {/* <small>Last Name</small> */}
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-person"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={otherName}
                              onChange={(e) => setOtherName(e.target.value)}
                              placeholder="Other Name"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-phone"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={phoneNumber}
                              onChange={handlePhoneNumberChange}
                              placeholder="Phone Number"
                              maxLength="11"
                              required
                            />
                          </div>
                          {phoneNumberError && (
                            <div
                              className="text-danger"
                              style={{ fontSize: "9px" }}
                            >
                              {phoneNumberError}
                            </div>
                          )}
                        </div>

                        <div className="flex-fill me-1 w-50">
                          {/* <small>Gender</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>Gender</small>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={gender}
                              onChange={(e) => setGender(e.target.value)}
                              required
                            >
                              <option>Male</option>
                              <option>Female</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Birth Date
                              </small>
                            </span>
                            <input
                              type="date"
                              className="form-control custom-input-group"
                              max={minDate.toISOString().split("T")[0]}
                              value={dateOfBirth}
                              onChange={(e) => setDateOfBirth(e.target.value)}
                              required
                            ></input>
                          </div>
                        </div>

                        <div className="flex-fill w-50 me-1">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-envelope"></i>
                            </span>
                            <input
                              type="email"
                              className="form-control custom-input-group"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              placeholder="Email"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill me-1 w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-person"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={maritalStatus}
                              onChange={(e) => setMaritalStatus(e.target.value)}
                              required
                            >
                              <option value="" selected disabled hidden>
                                Marital Status
                              </option>
                              <option value="Married">Married</option>
                              <option value="Single">Single</option>
                              <option value="Divorced">Divorced</option>
                              <option value="Seperated">Seperated</option>
                            </select>
                          </div>
                        </div>

                        <div className="flex-fill me-1 w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-person"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={nationality}
                              onChange={handleNationalityChange}
                              required
                            >
                              <option value="">Nationality</option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>

                      <section>
                        {/* <div className="d-flex">
                                                    <div>
                                                        <h2><i className="bi-geo-fill m-1 me-2 text-custom"></i></h2>
                                                    </div>
                                                    <div>
                                                        <h5 className="section-title text-custom" style={{ marginBottom: "-5px" }}>Address</h5>
                                                        <small className="text-muted">
                                                            Please provide us your address information
                                                        </small>
                                                    </div>
                                                </div> */}
                        <p
                          className="mt-3 bold text-small"
                          style={{ marginBottom: "5px" }}
                        >
                          Address
                        </p>

                        <div className="d-flex mt-2">
                          <div className="flex-fill  w-50 me-1">
                            <div className="input-group me-1">
                              <div className="input-group">
                                <span class="input-group-text input-group-text-custom">
                                  <i class="bi-map"></i>
                                </span>
                                <input
                                  type="text"
                                  className="form-control custom-input-group"
                                  value={address}
                                  onChange={(e) => setAddress(e.target.value)}
                                  placeholder="Residential Address"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flex-fill w-50 me-1">
                            <div className="input-group me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-pin-map"></i>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={addressCountryCode}
                                onChange={handleCountryChange}
                                required
                              >
                                <option>Country of Residence</option>
                                {/* <option value="Female">Female</option> */}
                                {countryList.map((cou) => {
                                  return (
                                    <option value={cou.COUNTRY_CD}>
                                      {cou.COUNTRY_DSC}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex mt-2">
                          <div className="flex-fill w-50 me-1">
                            <div className="input-group ">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-map"></i>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={state}
                                onChange={handleStateChange}
                                required
                              >
                                <option value="none">State of Residence</option>
                                {stList.map((state) => {
                                  return (
                                    <option value={state.STATE_CD}>
                                      {state.STATE_DSC}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="flex-fill w-50 me-1">
                            {/* <small>Date of Birth</small> */}
                            <div className="input-group me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-pin-map"></i>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={lga}
                                onChange={(e) => setLga(e.target.value)}
                                required
                              >
                                <option>Select LGA</option>
                                {lgaList.map((lga) => {
                                  return (
                                    <option value={lga.LGA_CD}>
                                      {lga.LGA_DSC}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        </div>
                        {/* <button className="btn-custom mt-2" onClick={handleStep2Submit}>Next</button> */}
                      </section>
                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep1Submit}
                        disabled={phoneNumberError}
                      >
                        Next
                      </button>
                      {phoneNumberError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "9px" }}
                        >
                          You cannot proceed until a valid phone number is
                          entered.
                        </div>
                      )}
                    </section>
                  )}

                  {/* NEXT OF KIN SECTION */}

                  {step2 && (
                    <section>
                      <div className="d-flex mb-3">
                        <div>
                          <h2>
                            <i className="bi-person-circle m-1 me-2 text-custom"></i>
                          </h2>
                        </div>
                        <div>
                          <h5
                            className="section-title text-custom"
                            style={{ marginBottom: "-5px" }}
                          >
                            Next of Kin
                          </h5>
                          <small className="text-muted">
                            Please provide us with your Next of Kin details.
                          </small>
                        </div>
                      </div>
                      <div className="d-flex">
                        {/* <div className="me-1 flex-fill">
                                                    {/* <small>Title</small> */}
                        {/* <div className="input-group">
                                                        <span class="input-group-text input-group-text-custom">
                                                            <i class="bi bi-person"></i>
                                                        </span>
                                                        <select className="form-control custom-input-group" value={nextOfKinTitleCd} onChange={(e) => setNextOfKinTitleCd(e.target.value)} placeholder="title" required>
                                                            <option>Select Title</option>
                                                            {titleList.map((tit) => {
                                                                return (
                                                                    <option value={tit.TITLE_CD}>
                                                                        {tit.TITLE_DSC}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div> */}

                        <div className="flex-fill me-1">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-person"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={nextOfKinFirstName}
                              onChange={(e) =>
                                setNextOfKinFirstName(e.target.value)
                              }
                              placeholder="First name"
                              required
                            />
                          </div>
                        </div>

                        <div className="flex-fill me-1">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-person"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={nextOfKinLastName}
                              onChange={(e) =>
                                setNextOfKinLastName(e.target.value)
                              }
                              placeholder="Last name"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      {/* Next of Kin Lastname and Firstname */}
                      <div className="d-flex mt-2">
                        <div className="ms-1 w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-telephone"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={nextOfKinTelephone}
                              onChange={(e) => handleKinPhoneNumberChange(e)}
                              placeholder="Next of Kin Phone Number"
                              min=""
                              required
                            />
                          </div>
                          {phoneNumberError && (
                            <div
                              className="text-danger"
                              style={{ fontSize: "9px" }}
                            >
                              {phoneNumberError}
                            </div>
                          )}
                        </div>

                        <div className="ms-1 w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-envelope"></i>
                            </span>
                            <input
                              type="email"
                              className="form-control custom-input-group"
                              value={nextOfKinEmailAddress}
                              onChange={(e) =>
                                setNextOfKinEmailAddress(e.target.value)
                              }
                              placeholder="Next of kin Email"
                              min=""
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          {/* <small>Date of Birth</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>Gender</small>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={nextOfKinGenderCd}
                              onChange={(e) =>
                                setNextOfKinGenderCd(e.target.value)
                              }
                              placeholder="title"
                              required
                            >
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          </div>
                        </div>

                        <div className="flex-fill w-50">
                          {/* <small>Mothers Maiden Name</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Relationship
                              </small>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={nextOfKinRelationshipCd}
                              onChange={(e) =>
                                setNextOfKinRelationshipCd(e.target.value)
                              }
                              required
                            >
                              {relationshipList.map((relationship) => {
                                return (
                                  <option value={relationship.RELATIONSHIP_CD}>
                                    {relationship.RELATIONSHIP_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          {/* <small>Date of Birth</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-pin-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={nextOfKinAddressCountryCd}
                              onChange={handleNokCountryChange}
                              required
                            >
                              <option>Country of Residence</option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="flex-fill w-50">
                          {/* <small>Mothers Maiden Name</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={nextOfKinAddressState}
                              onChange={handleNokStateChange}
                              required
                            >
                              <option value="none">State of Residence</option>
                              {nokStateList.map((state) => {
                                return (
                                  <option value={state.STATE_CD}>
                                    {state.STATE_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep2Submit}
                        disabled={phoneNumberError}
                      >
                        Next
                      </button>
                      {phoneNumberError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "9px" }}
                        >
                          You cannot proceed until a valid phone number is
                          entered.
                        </div>
                      )}

                      {/* <div>
                                                {
                                                    isPending ? (
                                                        <button className="btn-custom w-100 mt-3 btn-disabled" disabled>
                                                            <div class="spinner-border spinner-border-sm text-light ms-2"></div>
                                                        </button>
                                                    ) : (
                                                        <button className="btn-custom w-100 my-3" type="submit">
                                                            Continue
                                                        </button>
                                                    )
                                                }
                                            </div> */}
                    </section>
                  )}

                  {/* BANK INFO */}
                  {step3 && (
                    <section>
                      <div className="d-flex">
                        <div>
                          <h2>
                            <i className="bi-bank m-1 me-2 text-custom"></i>
                          </h2>
                        </div>
                        <div>
                          <h5
                            className="section-title text-custom"
                            style={{ marginBottom: "-5px" }}
                          >
                            Bank Details
                          </h5>
                          <small className="text-muted">
                            Please provide your bank account details
                          </small>
                        </div>
                      </div>
                      <p
                        className="mt-3 bold text-small"
                        style={{ marginBottom: "5px" }}
                      >
                        Bank Information
                      </p>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          {/* <small>Date of Birth</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-bank"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={bankName}
                              onChange={(e) => setBankName(e.target.value)}
                              required
                            >
                              <option value="" disabled selected hidden>
                                Select your Bank
                              </option>
                              {/* <option value="Female">Female</option> */}
                              {bankList.map((bank) => {
                                return (
                                  <option value={bank.BANK_CD}>
                                    {bank.BANK_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="flex-fill w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-briefcase"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={accountName}
                              onChange={(e) => setAccountName(e.target.value)}
                              placeholder="Account Name"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-briefcase"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={accountNumber}
                              onChange={handleAccountNumberChange}
                              placeholder="Account Number"
                              max=""
                              required
                            />
                          </div>
                          {accountNumberError && (
                            <div
                              className="text-danger"
                              style={{ fontSize: "9px" }}
                            >
                              {accountNumberError}
                            </div>
                          )}
                        </div>
                        <div className="flex-fill w-50">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-bank"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={bvn}
                              onChange={handleBVNChange}
                              placeholder="BVN"
                              min="10000000000"
                              max="99999999999"
                              maxLength="11"
                              required
                            />
                          </div>
                          {bvnError && (
                            <div
                              className="text-danger"
                              style={{ fontSize: "9px" }}
                            >
                              {bvnError}
                            </div>
                          )}
                        </div>
                      </div>
                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep3Submit}
                        disabled={bvnError || accountNumberError}
                      >
                        Next
                      </button>
                      {bvnError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "9px" }}
                        >
                          You cannot proceed until a valid BVN is entered.
                        </div>
                      )}
                      {accountNumberError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "9px" }}
                        >
                          You cannot proceed until a valid account number is
                          entered.
                        </div>
                      )}
                    </section>
                  )}
                  {/* IDENTITY INFO */}
                  {step4 && (
                    <section className="mt-4">
                      <div className="d-flex">
                        <div>
                          <h2>
                            <i className="bi-person-vcard m-1 me-2 text-custom"></i>
                          </h2>
                        </div>
                        <div>
                          <h5
                            className="section-title text-custom"
                            style={{ marginBottom: "-5px" }}
                          >
                            Identity Verification
                          </h5>
                          <small className="text-muted">
                            Provide a valid means of Identification
                          </small>
                        </div>
                      </div>
                      <p
                        className="mt-2 bold text-small"
                        style={{ marginBottom: "-2px" }}
                      >
                        Identity Verification
                      </p>
                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          {/* <small>Date of Birth</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-person-circle"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={identityDocTypeCd}
                              onChange={(e) =>
                                setIdentityDocTypeCd(e.target.value)
                              }
                              required
                            >
                              <option value="" disabled selected hidden>
                                Identity Type
                              </option>
                              {/* <option value="Female">Female</option> */}
                              {identityList.map((identity) => {
                                return (
                                  <option value={identity.IDENTIFICATION_CD}>
                                    {identity.IDENTIFICATION_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="flex-fill w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-file"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={identityDocNo}
                              onChange={(e) => setIdentityDocNo(e.target.value)}
                              placeholder="Document Number"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill me-1 w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Issue Date
                              </small>
                            </span>
                            <input
                              type="date"
                              className="form-control custom-input-group"
                              value={identityDocIssueDate}
                              max={new Date().toISOString().split("T")[0]}
                              onChange={handleIssueDateChange}
                              placeholder="Issue Date"
                              required
                            />
                          </div>
                        </div>

                        <div className="flex-fill w-50">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Exp Date
                              </small>
                            </span>
                            <input
                              type="date"
                              className="form-control custom-input-group"
                              value={identityDocExpiryDate}
                              min={identityDocIssueDate}
                              onChange={handleExpiryDateChange}
                              placeholder="Expiry Date"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <p
                        className="mt-2 bold text-small"
                        style={{ marginBottom: "-2px" }}
                      >
                        Document Uploads
                      </p>
                      <div className="d-flex mt-2">
                        <div className="flex-fill d-flex flex-column me-1 w-50">
                          <div className="input-group me-1 ">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Means of ID
                              </small>
                            </span>
                            <input
                              type="file"
                              className="form-control custom-input-group"
                              onChange={handleGovtID}
                              placeholder="Upload ID"
                              accept=".jpg, .jpeg, .png, .pdf"
                              required
                              multiple={false}
                            />
                          </div>
                          {/* <small style={{color: "red", fontSize: "10px"}}>Only .jpeg .jpg .png .pdf file allowed. Max file size is 1mb.</small> */}
                        </div>

                        <div className="flex-fill w-50">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Utility Bill
                              </small>
                            </span>
                            <input
                              type="file"
                              className="form-control custom-input-group"
                              onChange={handleutilityBill}
                              placeholder="Upload utility bill"
                              accept=".jpg, .jpeg, .png, .pdf"
                              multiple={false}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex mt-2">
                        <div className="flex-fill me-1 w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Passport
                              </small>
                            </span>
                            <input
                              type="file"
                              className="form-control custom-input-group"
                              onChange={handlePassport}
                              placeholder="Upload Passport or selfie"
                              accept=".jpg, .jpeg, .png, .pdf"
                              required
                              multiple={false}
                            />
                          </div>
                        </div>

                        <div className="flex-fill w-50">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Signature
                              </small>
                            </span>
                            <input
                              type="file"
                              className="form-control custom-input-group"
                              onChange={handleSignature}
                              placeholder="Upload signature."
                              accept=".jpg, .jpeg, .png, .pdf"
                              required
                              multiple={false}
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep4Submit}
                      >
                        Next
                      </button>
                    </section>
                  )}

                  {/* Submit Button */}

                  {finalStep && (
                    <section>
                      <div className="text-center">
                        <h1>
                          <i className="bi-person-check-fill"></i>
                        </h1>
                        {/* <h4 className="text-muted">Congratulations! You have completed the Form</h4> */}
                        <p>
                          To complete registeration, Please read and accept the
                          terms of Norrenberger.
                        </p>
                        <center>
                          <div className="input-group text-center">
                            <input
                              type="checkbox"
                              className="custom-input me-1"
                              onClick={handleCheckboxChange}
                            ></input>
                            I have read and accepted the{" "}
                            <button
                              className="custom-link mt-1"
                              onClick={(e) => {
                                e.preventDefault();
                                window.open(
                                  "https://assetmanagement.norrenberger.com/wp-content/uploads/2025/01/Terms-and-Conditions-1.pdf"
                                );
                              }}
                            >
                              Terms and Conditions of Norrenberger
                            </button>{" "}
                            of Norrenberger.
                          </div>
                        </center>
                      </div>
                      {isChecked && (
                        <div>
                          {isPending ? (
                            <button
                              className="btn-custom w-100 mt-3 btn-disabled"
                              disabled
                            >
                              <div class="spinner-border spinner-border-sm text-light ms-2"></div>
                            </button>
                          ) : (
                            <button
                              className="btn-custom w-100 my-3"
                              type="submit"
                            >
                              Submit
                            </button>
                          )}
                        </div>
                      )}
                    </section>
                  )}

                  <br />
                </form>
              </div>
            </div>

            <div className="col-xs-12 col-md-6 pt-3"></div>
          </div>
        </div>
      </div>

      <Footer />
      {/* <TermsModal /> */}
    </>
  );
};

export default NewIndividualForm;
